import { gql, useQuery } from '@apollo/client';

export default function useSharedRootSurface(id: string) {
  const query = gql`
    query fetchSharedRootSurface($id: ID!) {
      surfaceNode(id: $id) {
        data {
          ... on SubSurfaceNode {
            sharedRootSurface {
              name
            }
          }
        }
        error
        success
      }
    }
  `;
  const { data } = useQuery(query, {
    variables: { id },
    fetchPolicy: 'network-only',
  });

  return data?.surfaceNode?.data?.sharedRootSurface ?? null;
}
